import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { getAvailableItemsForWebsiteHeader } from 'src/shared/utils/website-header-utils'
import { useShouldShowRegistrationButtonInWebsiteHeader } from './use-should-show-registration-button-in-website-header'

export const useIsAllowedWebsiteHeaderEntity = (
  parentId: string = '',
  entityType: EntityTypeEnum,
): boolean => {
  const shouldShowRegistrationButton =
    useShouldShowRegistrationButtonInWebsiteHeader()

  const isAvailableItem = getAvailableItemsForWebsiteHeader(
    shouldShowRegistrationButton ? [] : [EntityTypeEnum.RegistrationButton],
  ).includes(entityType)

  return (
    usePage(page => pageSelectors.getEntityById(page, parentId || ''))?.type ===
      EntityTypeEnum.WebsiteHeader && isAvailableItem
  )
}
